// extracted by mini-css-extract-plugin
export default {"NavbarWrapper":"Navbar_NavbarWrapper__TKBZ-","logoutAvatarWrapper":"Navbar_logoutAvatarWrapper__eSAcU","avatarWrapper":"Navbar_avatarWrapper__zOov6"};